<template>
    <div @click="$emit('set-answer', answer.id)">
        <div
            v-if="selected"
            class="flex items-center gap-4 rounded border-2 border-primary-525 p-4 text-gray-700 hover:cursor-pointer"
        >
            <div class="flex-initial">
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect width="20" height="20" rx="4" fill="#0685BB" />
                    <path
                        d="M15.3307 6L7.9974 13.3333L4.66406 10"
                        stroke="white"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
            <div class="flex-1">
                {{ answer.text }}
            </div>
        </div>

        <div v-else class="border border-transparent">
            <div
                class="flex items-center gap-4 rounded border border-gray-200 p-4 text-gray-700 outline-1 hover:cursor-pointer hover:bg-gray-200"
            >
                <div class="flex-initial">
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect
                            x="0.5"
                            y="0.5"
                            width="19"
                            height="19"
                            rx="3.5"
                            fill="white"
                        />
                        <rect
                            x="0.5"
                            y="0.5"
                            width="19"
                            height="19"
                            rx="3.5"
                            stroke="#E4E6EA"
                        />
                    </svg>
                </div>
                <div class="flex-1">
                    {{ answer.text }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "StudentQuizQuestionAnswer",
    props: {
        answer: {
            type: Object,
            default: {},
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped></style>
